import type { EducationInputValue } from './types'

export const EDUCATION_INPUT_NAME = 'education'
export const EDUCATION_K_12_INPUT_NAME = 'expected-k-12-graduation-year'
export const EDUCATION_K_12_JOIN_REASON_INPUT_NAME = 'education-k-12-join-reason'
export const EDUCATION_K_12_SCHOOL_EXPERIENCE_INPUT_NAME = 'education-k-12-school-experience'
export const EDUCATION_NOT_K_12_JOIN_REASON_INPUT_NAME = 'education-not-k-12-join-reason'
export const HOW_DID_YOU_HEAR_INPUT_NAME = 'how_did_you_hear'
export const ZIPCODE_INPUT_NAME = 'zipcode'
export const PHONE_NUMBER_INPUT_NAME = 'phone_number'

export enum SchoolExperience {
  GoingPoorly = 'going-poorly',
  GoingAlright = 'going-alright',
  GoingWell = 'going-well',
}

export enum JoinReason {
  Tutor = 'tutor',
  School = 'school',
  TestPrep = 'test-prep',
  BeyondSchool = 'beyond-school',
  Tutoring = 'tutoring',
  Learning = 'learning',
  NotSure = 'not-sure',
}

export const EDUCATION_LABEL_BY_VALUES: Record<EducationInputValue, string> = {
  'k-12': 'K-12 Student',
  'university-student': 'University Student',
  'adult-learner': 'Adult / Professional',
  educator: 'Educator',
  other: 'Other',
} as const

export const PLATFORM_INTENT_VALUES = ['learner', 'tutor', 'both'] as const
export type PlatformIntent = (typeof PLATFORM_INTENT_VALUES)[number]

export const PRIMARY_INTENT_INPUT_NAME = 'primary-intent'

export const PRIMARY_INTENT_INPUT_OPTIONS: { value: PlatformIntent; label: string }[] = [
  { value: 'learner', label: 'Learner' },
  { value: 'tutor', label: 'Tutor' },
  { value: 'both', label: 'Both' },
]

export const BIRTH_YEARS: number[] = (() => {
  const options = []
  const currentYear = new Date().getFullYear()
  const minimumYear = 1900

  for (let i = currentYear; i >= minimumYear; i -= 1) {
    options.push(i)
  }

  return options
})()
